/**
 *
 * key
 *
 */

 const key = 'b3BlcmF0aW9uc015Rm9sbG93VXA='

 export default key
 